import { Component } from "@theme/component";

const CACHE_TTL_MS = 60 * 60 * 1000;
let inflight = null;

async function fetchRatings(id, publicCode) {
  const cacheKey = `wwk-ratings-${id}`;

  try {
    const cached = sessionStorage.getItem(cacheKey);
    if (cached) {
      const { data, expires } = JSON.parse(cached);
      if (expires > Date.now()) return data;
    }
  } catch {}

  if (inflight) return inflight;

  const url = `https://dashboard.webwinkelkeur.nl/api/1.0/ratings_summary.json?id=${encodeURIComponent(
    id,
  )}&public_code=${encodeURIComponent(publicCode)}`;

  inflight = fetch(url)
    .then((response) => response.json())
    .then((json) => {
      if (json?.status !== "success" || !json.data) return null;
      try {
        sessionStorage.setItem(
          cacheKey,
          JSON.stringify({ data: json.data, expires: Date.now() + CACHE_TTL_MS }),
        );
      } catch {}
      return json.data;
    })
    .catch(() => null)
    .finally(() => {
      inflight = null;
    });

  return inflight;
}

class WebwinkelkeurRating extends Component {
  async connectedCallback() {
    super.connectedCallback();

    const { webshopId, publicCode } = this.dataset;
    if (!webshopId || !publicCode) return;

    const data = await fetchRatings(webshopId, publicCode);
    if (!data) return;

    if (this.refs.rating) {
      const score = Number(data.rating_average).toLocaleString("nl-NL", {
        minimumFractionDigits: 1,
        maximumFractionDigits: 1,
      });
      this.refs.rating.textContent = score;
    }

    if (this.refs.count) {
      this.refs.count.textContent = data.amount;
    }
  }
}

if (!customElements.get("webwinkelkeur-rating")) {
  customElements.define("webwinkelkeur-rating", WebwinkelkeurRating);
}
